var map = {
	"./chart-blue.svg": 55684,
	"./chart.svg": 22143,
	"./depot-blue.svg": 74006,
	"./depot.svg": 4657,
	"./group.svg": 43918,
	"./groupp.svg": 91234,
	"./ship.svg": 88875,
	"./table-blue.svg": 62796,
	"./table.svg": 7799,
	"./triangle.svg": 13141,
	"./user.svg": 60792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30279;